import { render, staticRenderFns } from "./allstock-info.vue?vue&type=template&id=3a004ef6"
import script from "./allstock-info.vue?vue&type=script&lang=js"
export * from "./allstock-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports